module.exports = __webpack_public_path__ + "static/media/logo-retail-it.a227690c.png";